import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'sigv-library';

@Component({
  selector: 'sigv-extranet-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends BaseComponent implements OnInit {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
  }

}
